interface ApiErrorLike {
  response?: {
    data?: {
      message?: string;
    };
  };
  message?: string;
}

export const getErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  if (error && typeof error === "object") {
    const apiError = error as ApiErrorLike;
    if (apiError.response?.data?.message) {
      return apiError.response.data.message;
    }
    if (apiError.message) {
      return apiError.message;
    }
  }
  return fallback;
};
